<template>
  <div class="one-column-width">
    <v-card class="r_tabsform_card">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl">
        Add New Listing
      </v-card-title>
      <hr class="r_form_card_top_hr" />

      <div>
        <v-form ref="form" @submit.prevent="submit" class="">
          <v-container fluid>
            <v-col>
              <v-row class="">
                <div class="col-3 pt-0 inputs_mange">
                  <v-text-field
                    v-model="title"
                    :rules="rules.title"
                    color="purple name-2"
                    class="r_formtabs_inputs col-7"
                    label="Listing Name"
                    required
                    style="width: 100%; max-width: 100% !important;"
                  ></v-text-field>
                </div>
                <div class="col-3 pt-0 inputs_mange">
                  <v-autocomplete
                    v-model="campus_id"
                    :rules="rules.campus_id"
                    :items="campusesData"
                    item-text="text"
                    item-value="value"
                    class="r_formtabs_inputs col-7"
                    label="Select Campus"
                    @change="filterDepartment($event)"
                  ></v-autocomplete>

                </div>
                <div class="col-3 pt-0 inputs_mange">
                  <v-autocomplete
                    v-model="department_id"
                    :rules="rules.department_id"
                    :items="departmentsData"
                    class="r_formtabs_inputs col-7"
                    label="Select Department"
                    @change="filterProgram($event)"
                  ></v-autocomplete>
                </div>
                <div class="col-3 pt-0 inputs_mange">
                  <v-autocomplete
                    v-model="program_id"
                    :rules="rules.program_id"
                    :items="programsData"
                    class="r_formtabs_inputs col-7"
                    label="Select Program"
                  ></v-autocomplete>
                </div>
                <div class="col-3 pt-0 inputs_mange">
                  <v-autocomplete
                    :items="firstLevelCategoriesData"
                    class="r_formtabs_inputs col-7"
                    label="First Level category"
                    @change="filterSecondLevelCatigories($event)"
                  ></v-autocomplete>
                </div>
                <div class="col-3 pt-0 inputs_mange">
                  <v-autocomplete
                    :items="secondLevelCategoriesData"
                    class="r_formtabs_inputs col-7"
                    label="Second Level category"
                    @change="filterCatigories($event)"
                  ></v-autocomplete>
                </div>
                <div class="col-6 pt-0 inputs_mange">
                  <v-autocomplete
                    v-model="category_id"
                    :rules="rules.category_id"
                    :items="Categories"
                    class="r_formtabs_inputs col-7"
                    label="Main categories"
                  ></v-autocomplete>
                </div>
                <div class="col-3 pt-0 inputs_mange text-center">
                  <img class="display_img_view" :src="url" />
                  <v-file-input
                    style="font-size: 8px;"
                    class="r_formtabs_inputs col-7"
                    label="Main Banner"
                    @change="Preview_image"
                    v-model="image"
                    :rules="rules.image"
                  ></v-file-input>
                </div>
                <div class="col-md-3 pt-0 inputs_mange text-center">
                  <img class="display_img_view" :src="url2" />
                  <v-file-input
                    style="font-size: 8px;"
                    class="r_formtabs_inputs col-7"
                    label="Second Image"
                    @change="Preview_image_2"
                    v-model="image2"
                  ></v-file-input>
                </div>
                <div class="col-md-6 row m-0 pt-0 inputs_mange">
                  <v-file-input
                    style="font-size: 8px;"
                    class="r_formtabs_inputs col-7"
                    label="Brochure"
                    @change="pdf()"
                    v-model="brochure"
                  ></v-file-input>
                  <div class="col-6 checkbox_style p-0">
                    <v-checkbox
                      :class="[ mar_dis == true ? 'mar_dis' : '']"
                      @change="form_valdations()"
                      class="p-0 m-0 checkbox_ch"
                      v-model="send_enquiry"
                      label="Send Enquiry"
                      required
                    ></v-checkbox>
                  </div>
                  <div class="col-6 checkbox_style p-0">
                    <v-checkbox
                      :class="[dep_dis == true ? 'dep_dis' : '']"
                      @change="form_valdations()"
                      class="p-0 m-0 checkbox_ch"
                      v-model="admission_form_box"
                      label="Admission Form"
                      required
                    ></v-checkbox>
                  </div>
                  <v-autocomplete
                    v-model="admission_form_id"
                    :items="admissionForms"
                    v-if="admission_form_box == true"
                    class="r_formtabs_inputs col-7"
                    label="Admission Form"
                  ></v-autocomplete>
                </div>
                <div class="col-6">
                  <vue-editor
                    v-model="eligibility_criteria"
                    outlined
                    name="input-7-4"
                    label="About"
                    rows="3"
                    placeholder="Eligibility Criteria"
                  ></vue-editor>
                </div>
                <div class="col-6">
                  <vue-editor
                    v-model="description"
                    outlined
                    name="input-7-4"
                    label="About"
                    rows="3"
                    placeholder="Description"
                  ></vue-editor>
                </div>
                <!-- <template v-if="!editId">
                  <v-btn
                    class="custom-add-new-record-button"
                    type="button"
                    @click="addNewRow()"
                    >+</v-btn
                  >
                  <v-btn
                    v-if="index > 0"
                    class="custom-delete-new-record-button"
                    type="button"
                    @click="deleteRow(index)"
                    >-</v-btn
                  >
                </template> -->
              </v-row>
            </v-col>
          </v-container>
          <v-card-actions>
            <button class="r_form_add_more_btnnn" type="submit">
              <b-spinner small type="grow" v-if="submitting"></b-spinner>
              <span v-if="!editId">Submit</span>
              <span v-if="editId">Update</span>
            </button>
            <button
              type="button"
              @click="cancelForm"
              class="r_form_cancel_more_btnnn"
            >
              Cancel
            </button>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
  </div>
</template>

<script>
import ProgramService from '@/MainServices/ProgramService.js'
import SubjectService from '@/MainServices/SubjectService.js'
import ListingService from '@/MainServices/ListingService.js'
import CategoryService from '@/MainServices/CategoryService.js'
import { VueEditor } from 'vue2-editor'
import AdmissionForm from '@/MainServices/AdmissionForm.js';

import { required, minLength } from 'vuelidate/lib/validators'
export default {
  data() {
    return {
      title: '',
      campus_id: null,
      department_id: null,
      program_id: null,
      category_id: null,
      image: null,
      image2: null,
      brochure: null,
      admission_form_id: null,
      description: null,
      eligibility_criteria: null,
      campusesData: [],
      departmentsData: [],
      programsData: [],
      departments: [],
      programs: [],
      dep_dis: '',
      mar_dis: '',
      send_enquiry : '',
      admissionForms: [],
      url:
        'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png',
      url2:
        'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png',

      firstLevelCategoriesData: [],
      secondLevelCategoriesData: [],
      CategoriesData: [],
      secondLevelCategories: [],
      Categories: [],
      editId: null,
      deleteId: null,
      dialog: false,
      admission_form_box: '',
      rules: {
        title: [(val) => (val || '').length > 0 || 'Title is required'],
        campus_id: [(val) => !!val || 'Campus is required'],
        department_id: [(val) => !!val || 'Department is required'],
        program_id: [(val) => !!val || 'Program is required'],
        category_id: [(val) => !!val || 'Category is required'],
        image: [(val) => !!val || 'Image is required'],
        description: [
          (val) => (val || '').length > 0 || 'Description is required',
        ],
        eligibility_criteria: [
          (val) => (val || '').length > 0 || 'Eligibility criteria is required',
        ],
      },
      snackbar: false,
      snackBarText: null,
      submitting: false,
      deleting: false,
      errorMessage: false,
      search: '',
      showFormData: false,
      headers: [
        {
          text: 'Campus',
          align: 'left',
          sortable: false,
          value: 'campus',
          width: '20%',
        },
        {
          text: 'Department',
          align: 'left',
          sortable: false,
          value: 'department',
          width: '18%',
        },

        {
          text: 'Program',
          align: 'left',
          sortable: false,
          value: 'program',
          width: '15%',
        },
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'title',
          width: '20%',
        },
        {
          text: 'Plan',
          align: 'left',
          sortable: false,
          value: 'stripe_plan',
          width: '10%',
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      tableData: [],
    }
  },
  validations: {
    form: {
      required,
      $each: {
        title: { minLength: minLength(1), required },
        campus_id: { minLength: minLength(1), required },
        department_id: { minLength: minLength(1), required },
        program_id: { minLength: minLength(1), required },
        category_id: { minLength: minLength(1), required },
        image: { minLength: minLength(1), required },
        description: { minLength: minLength(1), required },
        eligibility_criteria: { minLength: minLength(1), required },
      },
    },
  },
  components: {
    VueEditor,
  },

  computed: {},

  methods: {
    form_valdations(){
    },
    getInititalData() {
      ListingService.getInstituteListings()
        .then((res) => {
          this.tableData = res.data
        })

        .catch(() => {
          this.loading = false
        })
    },
    // main methods
    Preview_image() {
      this.url = URL.createObjectURL(this.image)
    },
    Preview_image_2() {
      this.url2 = URL.createObjectURL(this.image2)
    },

    filterDepartment(id) {
      console.log('filter department', id);
      this.departments = this.departmentsData.filter((el) => {
        return el.campus_id == id
      })
    },
    filterProgram(id) {
      this.programs = this.programsData.filter((el) => {
        return el.department_id == id
      })
    },
    filterSecondLevelCatigories(id) {
      this.secondLevelCategories = this.secondLevelCategoriesData.filter(
        (el) => {
          return el.parentId == id
        },
      )
    },
    filterCatigories(id) {
      this.Categories = this.CategoriesData.filter((el) => {
        return el.parentId == id
      })
    },
    redirectToAddListing() {
      this.$router.push('/institute/add-listing')
    },
    showForm() {
      this.editId = null
      this.showFormData = true
      this.resetForm()
    },
    showEditForm(item) {
      this.form = [{ name: item.subject, program_id: item.program_id }]
      this.editId = item.id
      this.showFormData = true
    },
    cancelForm() {
      this.resetForm()

      this.showFormData = false

      this.$router.push('/institute/listings')
    },
    resetForm() {
      this.form = [{ city: '', country_id: null }]
      this.editId = null
      setTimeout(() => {
        if (this.$refs.form) {
          this.$refs.form.reset()
        }
      }, 100)
    },
    addNewRow() {
      this.form.push({ city: '', country_id: null })
    },
    deleteRow(index) {
      this.form.splice(index, 1)
    },
    submit() {
      this.submitting = true
      let formData = new FormData()
      formData.append('title', this.title)
      formData.append('campus_id', this.campus_id)
      formData.append('department_id', this.department_id)
      formData.append('program_id', this.program_id)
      formData.append('category_id', this.category_id)
      formData.append('image', this.image)
      formData.append('image2', this.image2)
      formData.append('brochure', this.brochure)
      formData.append('admission_form_id', this.admission_form_id)
      formData.append('description', this.description)
      formData.append('eligibility_criteria', this.eligibility_criteria)

      ListingService.addNewListing(formData)
        .then((res) => {
          this.resetForm()
          this.getInititalData()
          this.submitting = false
          this.snackBarText = 'New listing Added!'
          this.snackbar = true
          this.$router.push('/institute/listings')
        })
        .catch((error) => {
          this.errorMessage = true
        })

      // if (this.editId) {
      //   SubjectService.editSubject(this.form, this.editId)
      //     .then((res) => {
      //       this.resetForm();
      //       this.getInititalData();
      //       this.submitting = false;
      //       this.snackBarText = "City Updated successful!";
      //       this.snackbar = true;
      //     })
      //     .catch((error) => {
      //       this.errorMessage = true;
      //     });
      // } else {
      //   SubjectService.addNewSubjects(this.form)
      //     .then((res) => {
      //       this.resetForm();
      //       this.getInititalData();
      //       this.submitting = false;
      //       this.snackBarText = "Subject Added successful!";
      //       this.snackbar = true;
      //     })
      //     .catch((error) => {
      //       this.errorMessage = true;
      //     });
      // }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id
      this.dialog = true
    },
    deleteItem() {
      this.deleting = true
      SubjectService.deleteSubject(this.deleteId)
        .then((res) => {
          this.editId = null
          this.deleting = false
          this.dialog = false
          this.resetForm()
          this.getInititalData()
          this.snackBarText = 'Subject Deleted successful!'
          this.snackbar = true
        })
        .catch((error) => {
          this.errorMessage = true
          this.dialog = false
        })
    },
  },
  mounted() {
    this.getInititalData();
    AdmissionForm.getInstituteTemplates()
        .then((res) => {
          // res.data.map((el) => {
          //   el.form_json = JSON.parse(el.form_json);
          //   let names = el.form_json.map(x => x.question).join(", ");
          //   el.form_json = names;
          // })
          // this.tableData = res.data;
          res.data.map((el) => {
          this.admissionForms.push({
            value: el.id,
            text: el.form_name,
          })
        })
        })
        .catch(() => {
          this.loading = false
        })
    ProgramService.getInstitutePrograms()
      .then((res) => {
        res.data.map((el) => {
          this.campusesData.push({ value: el.id, text: el.name })
          console.log({ data: res.data })
          el.departments.map((el2) => {
            this.departmentsData.push({
              value: el2.id,
              text: el2.department,
              campus_id: el.id,
            })
            el2.programs.map((el3) => {
              this.programsData.push({
                value: el3.id,
                text: el3.program,
                department_id: el3.department_id,
              })
            })
          })
        })
      })
      .catch(() => {
        this.loading = false
      })
    CategoryService.getFirstLevelCategories()
      .then((res) => {
        res.data.map((el) => {
          this.firstLevelCategoriesData.push({
            value: el.id,
            text: el.category,
          })
        })
      })
      .catch((e) => {})
    CategoryService.getSecondLevelCategories()
      .then((res) => {
        res.data.map((el) => {
          this.secondLevelCategoriesData.push({
            value: el.id,
            text: el.category,
            parentId: el.first_level_categories_id,
          })
        })
      })
      .catch((e) => {})
    CategoryService.getCategories()
      .then((res) => {
        res.data.map((el) => {
          this.CategoriesData.push({
            value: el.id,
            text: el.category,
            parentId: el.second_level_categories_id,
          })
        })
      })
      .catch(() => {
        this.loading = false
      })
  },
}
</script>

<style scoped>
.text-success {
  color: #2eca8b !important;
}
.text-danger {
  color: #a82511 !important;
}
</style>
